import { useParams, useSearchParams } from "react-router-dom";

import { DagViewerSurface } from "../features/dag-viewer";

/** Standalone lineage route, now backed by the same canonical viewer as V5. */
export default function WarpLineagePage() {
  const { projectId = "" } = useParams<{ projectId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedId = searchParams.get("nodes");
  const branch = searchParams.get("branch") || "main";
  const selectNode = (nodeId: string | null) => {
    setSearchParams((current) => {
      const next = new URLSearchParams(current);
      if (nodeId) next.set("nodes", nodeId);
      else next.delete("nodes");
      return next;
    }, { replace: true });
  };

  return (
    <div style={{ display: "flex", height: "100vh", minHeight: 0 }}>
      <DagViewerSurface
        projectId={projectId}
        projectName="Project lineage"
        branch={branch}
        selectedNodeId={selectedId}
        onSelectNode={selectNode}
      />
    </div>
  );
}
